import { render, staticRenderFns } from "./MallTabPlus.vue?vue&type=template&id=c6ed081c&"
import script from "./MallTabPlus.vue?vue&type=script&lang=ts&"
export * from "./MallTabPlus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports